<template>
    <v-toolbar flat color="white">
        <v-radio-group
            max-length="256"
            v-model="searchWord.gender"
            row
            label="性別"
            class="customClass ml-7"
            >
            <v-radio label="男性" value="0"/>
            <v-radio label="女性" value="1"/>
            <v-radio label="指定なし" value="2"/>
        </v-radio-group>
        <div class="searchBoxLabel ml-7">誕生日</div>
        <div class="inputBox">
            <v-text-field
                class="m-1"
                inputmode="tel"
                type="tel"
                placeholder="0000-00-00"
                maxlength="10"
                @focus="focusDate(searchWord.birthdayFrom)"
                @input="searchWord.birthdayFrom = $event"
                :value="formatedDate(searchWord.birthdayFrom)"
                @keyup.delete="deleteKeyUpBirthdayFrom($event)"
                @keyup="searchWord.birthdayFrom = formatDate(searchWord.birthdayFrom)"
                :rules="[rules.string_type,
                         rules.format_date,
                         rules.correct_date]"
            />
        </div>
        <span class="d-flex align-center flex-nowrap mx-2 pb-4 pt-2">〜</span>
        <div class="inputBox">
            <v-text-field
                placeholder="0000-00-00"
                maxlength="10"
                inputmode="tel"
                type="tel"
                @focus="focusDate(searchWord.birthdayTo)"
                @input="searchWord.birthdayTo = $event"
                :value="formatedDate(searchWord.birthdayTo)"
                @keyup.delete="deleteKeyUpBirthdayTo($event)"
                @keyup="searchWord.birthdayTo = formatDate(searchWord.birthdayTo)"
                :rules="[rules.string_type,
                         rules.format_date,
                         rules.correct_date]"
            />
        </div>
        <div class="searchBoxLabel ml-7">登録日</div>
        <div class="inputBox">
            <v-text-field
                placeholder="0000-00-00"
                maxlength="10"
                inputmode="tel"
                type="tel"
                @focus="focusDate(searchWord.registdayFrom)"
                @input="searchWord.registdayFrom = $event"
                :value="formatedDate(searchWord.registdayFrom)"
                @keyup.delete="deleteKeyUpRegistdayFrom($event)"
                @keyup="searchWord.registdayFrom = formatDate(searchWord.registdayFrom)"
                :rules="[rules.string_type,
                         rules.format_date,
                         rules.correct_date]"
            />
        </div>
        <span class="d-flex align-center flex-nowrap mx-2 pb-4 pt-2">〜</span>
        <div class="inputBox">
            <v-text-field
                placeholder="0000-00-00"
                maxlength="10"
                class="pr-2"
                inputmode="tel"
                type="tel"
                @focus="focusDate(searchWord.registdayTo)"
                @input="searchWord.registdayTo = $event"
                :value="formatedDate(searchWord.registdayTo)"
                @keyup.delete="deleteKeyUpRegistdayTo($event)"
                @keyup="searchWord.registdayTo = formatDate(searchWord.registdayTo)"
                :rules="[rules.string_type,
                         rules.format_date,
                         rules.correct_date]"
            />
        </div>
        <v-btn
            color="primary"
            class="ml-7"
            @click="reference"
            :disabled="btn[1].isActive">検索</v-btn>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
import validater from '@/lib/validater';
import { utilityMixin } from '@/mixins/utility';

export default {
    props: {
        searchWord: {
            type: Object
        },
        admin: {
            type: Object,
            default: () => ({
                user_id: '',
                user_div: '',
                golf_code: ''
            })
        },
        btn: {
            type: Array,
            default: () => {}
        }
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    watch: {
        'searchWord.birthdayFrom': function (val) {
            return this.searchWord.birthdayFrom.replace(/\D|-/g, '');
        }
    },
    methods: {
        reference () {
            this.$emit('event');
        },
        /** --------------------------------------------
        * 期間限定の場合終了日が開始日より前日になっていないか
        * -------------------------------------------- */
        checkstartDate (enddate) {
            let startdate = this.searchWord.birthdayFrom.replace(/-/g, '');
            startdate = Number(startdate);
            enddate = enddate.replace(/-/g, '');
            enddate = Number(enddate);
            if (startdate >= enddate) {
                return false;
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpBirthdayFrom (event) {
            this.searchWord.birthdayFrom = this.formatDate(this.searchWord.birthdayFrom);
            this.searchWord.birthdayFrom = this.deleteKeyDelete(event);
        },
        deleteKeyUpBirthdayTo (event) {
            this.searchWord.birthdayTo = this.formatDate(this.searchWord.birthdayTo);
            this.searchWord.birthdayTo = this.deleteKeyDelete(event);
        },
        deleteKeyUpRegistdayTo (event) {
            this.searchWord.registdayFrom = this.formatDate(this.searchWord.registdayFrom);
            this.searchWord.registdayFrom = this.deleteKeyDelete(event);
        },
        deleteKeyUpRegistdayFrom (event) {
            this.searchWord.registdayTo = this.formatDate(this.searchWord.registdayTo);
            this.searchWord.registdayTo = this.deleteKeyDelete(event);
        }
    }
};
</script>

<style scoped>

.searchBoxLabel{
    margin: 0px 5px;
    padding: 5px;
    height: 40px;
    font-size: 16px;
}

.v-toolbar__content, .v-toolbar__extension{
    align-items: baseline;
}

.inputBox{
    width: 90px;
}

.v-tool-bar{
    font-size: 15px;
}

.v-text-field ::v-deep input{
    padding: 8px 0 0 0;
}

.v-radio ::v-deep legend{
    font-size: 15px;
}

.v-radio ::v-deep label{
    font-size: 15px;
}

.customClass{
    padding-top: 13px;
}

.customClass ::v-deep i{
    font-size: 15px;
}

</style>
